var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"toolbar",class:[
    // Position
    'absolute',
    _setup.isDoubleColumnLayout && ['w-[92px]'],
    _setup.isSingleColumnLayout && ['w-[52px]', 'max-h-full', 'overflow-x-hidden', 'overflow-y-auto', 'py-4', 'box-border'],
    _setup.isSingleRowLayout && [
      'bottom-0',
      'start-1/2',
      '-translate-x-2/4',
      'flex-row',
      'max-w-full',
      'overflow-x-auto',
      'overflow-y-hidden',
      'px-4 pb-1.5',
      'box-border',
    ],
    !_setup.isSingleRowLayout && ['end-0', 'top-1/2', '-translate-y-2/4', 'flex-col'],

    'z-edit-post',

    // Children positioning
    'flex',

    'gap-2',
  ],style:({
    insetInlineEnd: !_setup.isSingleRowLayout ? _setup.surfaceWindowMobileNotchStore.safeAreaInsetEnd + 'px' : undefined,
  })},_vm._l((_setup.whiteboardStore.toolSections),function(toolSection,index){return _c(_setup.OzBox,{key:'tool-section-' + index,class:[
      // Color
      {
        'bg-popover-dark': _setup.colorScheme === 'dark',
        'bg-popover-light': _setup.colorScheme === 'light',
      },
      'backdrop-blur-10',

      // Shape
      !_setup.isLoadingPortraitMobileLayout && ['rounded-s-xl'],
      _setup.isLoadingPortraitMobileLayout && ['rounded-xl'],
      !_setup.isLoadingPortraitMobileLayout &&
        !_setup.surfaceWindowMobileNotchStore.isApplyingSafeAreaInsetEnd && ['rounded-e-none'],
      !_setup.isLoadingPortraitMobileLayout && _setup.surfaceWindowMobileNotchStore.isApplyingSafeAreaInsetEnd && ['rounded-e-xl'],

      'p-1',

      // Children positioning
      _setup.isDoubleColumnLayout && ['grid', 'grid-cols-2', 'gap-1'],
      // !isLoadingPortraitMobileLayout && index === 0 && ['flex-row-reverse'],
      _setup.isSingleRowLayout && index > 0 && ['flex', 'flex-row', 'gap-1'],
      _setup.isSingleRowLayout && index === 0 && ['flex', 'flex-row-reverse', 'gap-1'],
      _setup.isSingleColumnLayout && index > 0 && ['flex', 'flex-col', 'gap-1'],
      _setup.isSingleColumnLayout && index === 0 && ['flex', 'flex-col-reverse', 'gap-1'],
    ],attrs:{"radius":0,"color":_setup.OzBoxColors.None,"dark-mode":_setup.colorScheme === 'dark'}},_vm._l((toolSection.map((toolId) => _setup.toolsToShow.find((tool) => toolId === tool.id)).filter((t) => !!t)),function(tool){return _c(_setup.WhiteboardToolbarIcon,{key:`${tool.id}`,attrs:{"is-selected":tool.id === _setup.whiteboardStore.selectedToolId,"color-scheme":_setup.colorScheme,"color-style":!!_setup.whiteboardStore.selectedSecondaryTool ? 'opaque' : 'frosted',"icon-name":tool.iconName,"secondary-menu":tool.secondaryMenu,"secondary-selection-id":_setup.whiteboardStore.toolStates[tool.id].currentSecondarySelectionId,"current-tool-color":_setup.whiteboardStore.toolCurrentColors[tool.id],"label":tool.label,"shortcut":tool.shortcut,"x-tooltip":_setup.xTooltip && _setup.tooltipToolId === tool.id,"disabled":_setup.toolDisabledState[tool.id]},on:{"click":function($event){return _setup.handleSelectTool($event, tool.id)},"hoveron":function($event){return _setup.trackToolHoverOn(tool.id)},"hoveroff":_setup.trackToolHoverOff}})}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }